const saathiReturnsConstValues = {
  maxReturnQuantity: 2000,
  minimumOrderQuantity: 5,
  saathiReturnsRecentOrdersDurationInDays: 120,
  fieldReturnsRecentOrdersDurationInDays: 360,
};

export default saathiReturnsConstValues;
